import { inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';

import { forkJoin } from 'rxjs';

import { ApiService } from '@services/api.service';
import { AlertType, FormAlert } from '@components/alert/alert.component';

export class Params {
  take: number = 12;
  size: number = 12;
  page: number = 1;
}
export abstract class FormComponent {
  protected api = inject(ApiService);
  protected formBuilder = inject(FormBuilder);
  protected route = inject(ActivatedRoute);

  alertData = signal<FormAlert | null>(null);
  data: any = {};
  // ! USED FOR CRUD REQUESTS ONLY
  endpoint: string = '';
  form: FormGroup | null = null;
  initialized = signal<boolean>(false);
  loadEndpoint: string = '';
  loading = signal<boolean>(false);
  method: string = 'get';
  params: Params = new Params();
  services: string[] = [];

  cacheLoadServices() {
    const options = {
      headers: {
        ['CacheInterceptor']: 'true',
      },
    };

    this.loadServices(options);
  }

  loadServices(options?: any) {
    if (this.services.length === 0) return;

    this.startLoading();

    const services = this.services.map((service) =>
      this.api.call({
        service,
        method: 'get',
        ...options,
      }),
    );

    forkJoin(services).subscribe({
      next: (data) => {
        this.onLoadServicesSuccess(data);
      },
      error: (error) => {
        this.onLoadServicesError(error);
      },
    });
  }

  onLoadServicesSuccess(responses: any[]): void {
    this.initialized.set(true);
    this.stopLoading();
  }

  onLoadServicesError(errors: any[]): void {
    this.initialized.set(true);
    this.stopLoading();
  }

  cacheLoad() {
    const options = {
      headers: {
        ['CacheInterceptor']: 'true',
      },
    };

    this.load(options);
  }

  load(options?: any) {
    this.startLoading();

    this.api
      .call({
        service: this.loadEndpoint,
        method: 'get',
        params: this.getQueryParams(),
        ...options,
      })
      .subscribe({
        next: (response) => {
          if (response.status == 200) {
            this.onLoadSuccess(response);
          } else {
            this.onLoadError(response.message);
          }
        },
        error: (error) => {
          this.onLoadError(error);
        },
      });
  }

  onLoadSuccess(response: any): void {
    this.initialized.set(true);
    this.stopLoading();
  }

  onLoadError(error: any): void {
    this.initialized.set(true);
    this.stopLoading();
  }

  getQueryParams(): any {
    // const params: any = {};

    // const { size, ...paramsQ } = { ...this.params };

    // for (const [key, value] of Object.entries(paramsQ)) {
    //   if (value !== -1 && value !== null && value !== '') {
    //     params[key] = value;
    //   }
    // }

    // return params;
    return '';
  }

  isValid(): boolean {
    return true;
  }

  getParams() {
    return this.data;
  }

  getOptions(): any {
    return null;
  }

  getContext(): any {
    return null;
  }

  handleSubmit() {
    this.alertData.set(null);

    if (this.loading()) {
      return;
    }

    this.submit();
  }

  submit() {
    this.alertData.set(null);

    if (!this.isValid()) return;

    this.startLoading();

    const formRequest = {
      service: this.endpoint,
      method: this.method,
      params: this.getParams(),
      ...(this.getContext() ? { context: this.getContext() } : {}),
      ...(this.getOptions() ? { options: this.getOptions() } : {}),
    };

    this.api.call(formRequest).subscribe({
      next: (response) => {
        this.success(response);
      },
      error: (error) => {
        console.error(error);
        this.failed(error.message ?? error);
      },
    });
  }

  success(_response: any) {
    this.stopLoading();
  }

  failed(error: any) {
    this.handleAlert(error);

    this.stopLoading();
  }

  handleAlert(message: string, type: AlertType = 'danger') {
    this.alertData.set({
      message,
      type,
    });

    this.stopLoading();
  }

  startLoading() {
    this.alertData.set(null);
    this.loading.set(true);
  }

  stopLoading() {
    this.loading.set(false);
  }
}
